<script setup>
import Section from '@/components/Section.vue';
import {onMounted, ref} from 'vue';
import { render } from './tools';
import Wrapper from '@/components/Wrapper.vue';

const container = ref(null);

onMounted(() => {
    if (container.value) {
        render(container.value);
    }
});
</script>

<template>
    <Section id="actions">
        <h1>
            Actions to reduce air pollution
        </h1>
        <h2>
            <span>
                What are the means to reduce air emissions over the next 15 years?
            </span>
        </h2>

        <Wrapper>
        <div ref="container" class="container" />
        </Wrapper>
    </Section>
</template>


<style lang="scss" scoped>
.container {
    height: 400px;
}
</style>
